import 'core-js/stable';
import 'isomorphic-fetch';
import 'raf/polyfill';
import 'regenerator-runtime/runtime';
import { render } from 'react-dom';

import OmbudsmanExtRoot from './OmbudsmanExtRoot';

render(<OmbudsmanExtRoot />, document.getElementById('root'));
